import React from 'react';

function NotFoundPage() {
    return (
        <div className='flex flex-col items-center justify-center min-h-screen gap-5 px-6 text-center'>
            <img
                src='/assets/img/mascot/mascot1.svg'
                alt=''
                className='w-40 sm:w-48 h-auto'
            />
            <div className='flex flex-col gap-1'>
                <h1 className='text-5xl font-extrabold text-arsen-quaternary-950'>404</h1>
                <p className='text-lg text-gray-500'>Halaman yang kamu cari tidak ditemukan.</p>
            </div>
            <a
                href='/'
                className='px-8 py-3 rounded-xl bg-arsen-primary text-white font-semibold text-sm hover:bg-arsen-primary-600 hover:shadow-lg transition-all duration-200'
            >
                Kembali ke arsenunair.com
            </a>
        </div>
    );
}

export default NotFoundPage;
